import styled from '@emotion/styled';

export const SadaApplicants = styled.div``;
